// Add all possible Line of Business under this object
export const LOB = {
  DASHBOARD: 'Dashboard',
  MUTUAL_FUNDS: 'Mutual Fund',
  US_STOCKS: 'US Stocks',
  IN_STOCKS: 'IN Stocks',
  SUBSCRIPTIONS: 'Subscriptions',
  HOMEPAGE: 'HomePage',
  GOALS: 'Goals',
  NOTIFICATIONS: 'Notifications',
  BLOGS: 'Blogs',
  OTHERS: 'Others',
  PAYMENTS: 'Payments',
  REMITTANCE: 'Remittance',
  KYC: 'KYC',
  LEARN: 'LEARN',
  FD: 'FD',
  FEATURES: 'FEATURES',
  CALCULATORS: 'Calculators',
  GUIDES: 'Guides',
  INSURANCE: 'Insurance',
  PNL: 'PNL',
  IPO: 'IPO',
  FNO: 'FNO',
  WALLET: 'WALLET',
  ORDERBOOK: 'ORDERBOOK',
  NEWS: 'NEWS',
  SEARCH: 'SEARCH',
}

// Naming Convention for Events :
// 1. Start with EN -> indicates Event Name
// 2. Add POD name -> eg: For Mutual Funds (MF), US Stocks (US) etc.
// 3. Add event name

export const EN_HEADER_LINKS = 'header_links'

// ------------- MF EVENTS START -------------
export const EN_MF_EXPLORE_LAND = 'mf_ma_explore_land'
export const EN_MF_CATEGORY_CLICK = 'mf_ma_category_clicked'
export const EN_MF_LISTING_LAND = 'mf_fund_listing_view_v2' // BE driven event
export const EN_MF_DETAILS_LAND = 'mf_fund_details_view'
export const EN_MF_LUMPSUM_CLICK = 'mf_direct_ls_start' // BE driven event
export const EN_MF_SIP_CLICK = 'mf_direct_sip_start' // BE driven event
export const EN_MF_INVEST_MORE_CLICK = 'mf_my_fund_detail_cta_clicked' // BE driven event
export const EN_MF_SWITCH_CLICK = 'mf_my_fund_detail_bs_cta_clicked' // BE driven event
export const EN_MF_CONTINUE_INVEST_CLICK = 'mf_common_investment_screen_clicked'
export const EN_MF_CONTINUE_REDEEM_CLICK = 'mf_redeem_continue'
export const EN_MF_SUCCESS_REDEEM_CLICK = 'mf_redeem_success'
export const EN_MF_SIDEBAR_CLICK = 'mf_sidebar_click'

// ------------- PAYMENTS EVENTS START ---------------

export const EN_PAYMENTS_ALERT_BOTTOM_SHEET_CTA_CLICKED =
  'payments_alert_bottom_sheet_cta_clicked'
export const EN_PAYMENTS_ALERT_BOTTOM_SHEET_OPENED =
  'payments_alert_bottom_sheet_opened'
export const EN_PAYMENTS_BANK_SELECT_BOTTOMSHEET_OPENED =
  'payments_bank_select_bottomsheet_opened'
export const EN_PAYMENTS_BANK_SELECT_BOTTOMSHEET_PAYNOW =
  'payments_bank_select_bottomsheet_paynow'
export const EN_PAYMENTS_BANK_SELECT_OPENED = 'payments_bank_select_opened'
export const EN_PAYMENTS_INTERCEPTION_DONE = 'payments_interception_done'
export const EN_PAYMENTS_INTERCEPTION_FAILURE = 'payments_interception_failure'
export const EN_PAYMENTS_INVALID_CTA = 'payments_invalid_cta'
export const EN_PAYMENTS_OPTIONS_INVALID_PARAMS_SCREEN_CLOSED =
  'payments_options_invalid_params_screen_closed'
export const EN_PAYMENTS_OPTIONS_SCREEN_OPENED =
  'payments_options_screen_opened'
export const EN_PAYMENTS_POLLING_API_FAILURE = 'payments_polling_api_failure'
export const EN_PAYMENTS_POLLING_ENDED = 'payments_polling_ended'
export const EN_PAYMENTS_SELECT_METHOD = 'payments_select_method'
export const EN_PAYMENTS_WEBVIEW_CLOSE_CLICKED =
  'payments_webview_close_clicked'
export const EN_PAYMENTS_WEBVIEW_CLOSED = 'payments_webview_closed'
export const EN_PAYMENTS_WEBVIEW_ERROR = 'payments_webview_error'
export const EN_PAYMENTS_WEBVIEW_OPENED = 'payments_webview_opened'
export const EN_PAYMENTS_ADDBANK_BANK_SELECTED =
  'payments_addbank_bank_selected'
export const EN_PAYMENTS_ADDBANK_BANK_SEARCH_CLICKED =
  'payments_addbank_bank_search_clicked'
export const EN_PAYMENTS_ADDBANK_BRANCH_CHANGEBANK_CLICKED =
  'payments_addbank_branch_changebank_clicked'
export const EN_PAYMENTS_ADDBANK_BRANCH_SELECTED =
  'payments_addbank_branch_selected'
export const EN_PAYMENTS_ADDBANK_BRANCH_SEARCH_CLICKED =
  'payments_addbank_branch_search_clicked'
export const EN_PAYMENTS_ADDBANK_VERIFYBANK_CLICKED =
  'payments_addbank_verifybank_clicked'
export const EN_PAYMENTS_ADDBANK_STATUS_CONTINUE_CLICKED =
  'payments_addbank_status_continue_clicked'
export const EN_PAYMENTS_ADDBANK_STATUS_VIEWED =
  'payments_addbank_status_viewed'
export const EN_PAYMENTS_ADDBANK_BANK_LIST_VIEWED =
  'payments_addbank_bank_list_viewed'
export const EN_PAYMENTS_ADDBANK_BRANCH_LIST_VIEWED =
  'payments_addbank_branch_list_viewed'

// All pages events

export const EN_ALL_HAMBURGER_LINKS = 'hamburger_links'
export const EN_ALL_SEARCH = 'search'
export const EN_ALL_SEARCH_CARD_CLICKED = 'search_card_clicked'
export const EN_ALL_SEARCH_SECTION_CLICKED = 'search_section_clicked'
export const EN_ALL_FOOTER_LINKS = 'footer_links'

// Home page events

export const EN_HOME_APP_STORE_CLICK = 'app_store_click'
export const EN_HOME_PLAY_STORE_CLICK = 'play_store_click'
export const EN_HOME_HOMEPAGE_SUPERAPP = 'homepage_superapp'
export const EN_HOME_HOMEPAGE_EXPLORE_CLICKS = 'homepage_explore_clicks'
export const EN_HOME_HOMEPAGE_GET_USSTOCKS_CLICK = 'homepage_get_usstocks_click'

// US STOCKS

// doesn't follow the naming convention at the top of the file
// if you add any new events of us stocks or elsewhere please use that convention.

export const US_STOCKS_EXPLORE_ALL = 'usstock_db_viewed'
export const US_STOCKS_CHILD_PAGE_VIEW = 'usstock_stockdetailpage_viewed'
export const US_STOCKS_BUY_CTA_CLICK = 'usstock_stockdetailpage_buy_click'
export const US_STOCKS_SIP_CTA_CLICK = 'usstock_stockdetailpage_sip_click'
export const US_STOCKS_SELL_CTA_CLICK = 'usstock_stockdetailpage_sell_click'
export const US_STOCKS_SUCCESS_BUY_SELL = 'usstock_buysellpage_cta_clicked'

// US STOCKS REMITTANCE
export const EN_US_REMITTANCE_ADD_MONEY_PAGE_VIEW =
  'usstock_addmoneypage_viewed'
export const EN_US_REMITTANCE_ADD_MONEY_CONTINUE_CTA_CLICK =
  'usstock_addmoneypage_cta_clicked'
export const EN_US_REMITTANCE_CONFIRM_REMITTANCE_PAGE_VIEW =
  'us_sbm_review_remittance_details'
/**
 * Nishant has confirmed that `us_sbm_funds_under_processing` page is used by marketing folks for something ( something related to identifying look alike user or something ). Indicative par nishant uses `funding_timeline` event, but he asked me to go ahead and add `us_sbm_funds_under_processing` only for GA4 until someone corrects us if need be.
 */
export const EN_US_REMITTANCE_TIMELINE_STATUS_PAGE_VIEW =
  'us_sbm_funds_under_processing'

// CUSTOMER SERVICE PAGE
export const WEB_HELPDESK_RAISE_A_TICKET = 'Web_helpdesk_raise_a_ticket'
export const WEB_HELPDESK_TOPIC = 'Web_helpdesk_topic'
export const WEB_HELPDESK_ESCALATION_MATRIX = 'Web_helpdesk_escalation_matrix'

// KYC
export const KYC_ACCOUNT_INTRO_PAGEVIEW = 'kyc2_account_creation_intro_viewed'
export const KYC_ACCOUNT_INTRO_NEXT_CTA_CLICK =
  'kyc2_account_creation_intro_next_clicked'
export const KYC_CONFIRM_PAN_PAGEVIEW = 'kyc2_pan_basic_details_viewed'
export const KYC_CONFIRM_PAN_NEXT_CTA_CLICK =
  'kyc2_pan_basic_details_next_clicked'
export const KYC_RESIDENCE_DETAILS_PAGEVIEW = 'kyc2_residence_details_viewed'
export const KYC_RESIDENCE_DETAILS_NEXT_CTA_CLICK =
  'kyc2_residence_details_next_clicked'
export const KYC_PERSONAL_DETAILS_1_PAGEVIEW = 'kyc2_personal_details_1_viewed'
export const KYC_NOMINEE_RELATION_PAGEVIEW = 'kyc2_nominee_consent_viewed'
export const KYC_PERSONAL_DETAILS_1_NEXT_CTA_CLICK =
  'kyc2_personal_details_1_next_clicked'
export const KYC_NOMINEE_RELATIONS_CHECKBOX_CLICKED =
  'kyc2_nominee_relation_viewed'
export const KYC_NOMINEE_CLICKED_NEXT_CTA_CLICKED =
  'kyc2_nominee_relation_next_clicked'
export const KYC_PERSONAL_DETAILS_2_PAGEVIEW = 'kyc2_personal_details_2_viewed'
export const KYC_PERSONAL_DETAILS_2_NEXT_CTA_CLICK =
  'kyc2_personal_details_2_viewed'
export const KYC_EMPLOYED_CHOICE_SELECTED = 'kyc2_employment_details_viewed'
export const KYC_EMPLOYED_NEXT_CTA_CLICK =
  'kyc2_employment_details_next_clicked'
export const KYC_STOCKS_ACCOUNT_STATUS_PAGVIEW = 'kyc2_kyc_status_viewed'
export const KYC_STOCKS_ACCOUNT_STATUS_CTA_CLICK =
  'kyc2_kyc_status_next_clicked'
export const KYC_DIGIO_PAGEVIEW =
  'kyc2_address_verification_digio_aadhaar_viewed'
export const KYC_DIGIO_NEXT_CTA_CLICK =
  'kyc2_address_verification_digio_aadhaar_next_clicked'
export const KYC_DL_FRONT_UPLOAD_PAGEVIEW =
  'kyc2_address_verification_dl_front_viewed'
export const KYC_DL_FRONT_UPLOAD_NEXT_CTA_CLICK =
  'kyc2_address_verification_dl_front_next_clicked'
export const KYC_DL_BACK_UPLOAD_PAGEVIEW =
  'kyc2_address_verification_dl_rear_viewed'
export const KYC_DL_BACK_UPLOAD_NEXT_CTA_CLICK =
  'kyc2_address_verification_dl_rear_next_clicked'

export const KYC_PASSPORT_FRONT_UPDATE_PAGEVIEW =
  'kyc2_address_verification_front_dl_viewed'
export const KYC_PASSPORT_FRONT_NEXT_CTA_CLICK =
  'kyc2_address_verification_front_dl_next_clicked'
export const KYC_PASSPORT_BACK_UPDATE_PAGEVIEW =
  'kyc2_address_verification_rear_dl_viewed'
export const KYC_PASSPORT_BACK_NEXT_CTA_CLICK =
  'kyc2_address_verification_rear_dl_next_clicked'

export const KYC_DL_INPUT_PAGEVIEW =
  'kyc2_address_verification_data_input_dl_viewed'
export const KYC_DL_INPUT_NEXT_CTA_CLICK =
  'kyc2_address_verification_data_input_dl_next_clicked'
export const KYC_PASSPORT_INPUT_PAGEVIEW =
  'kyc2_address_verification_data_input_passport_viewed'
export const KYC_PASSPORT_INPUT_NEXT_CTA_CLICK =
  'kyc2_address_verification_data_input_passport_next_clicked'

export const KYC_PAN_UPLOAD_PAGEVIEW = 'kyc2_pan_upload_viewed'
export const KYC_PAN_UPLOAD_NEXT_CTA_CLICK = 'kyc2_pan_upload_next_clicked'

export const KYC_EMAIL_VERIFIED_PAGEVIEW = 'kyc2_email_verify_viewed'
export const KYC_EMAIL_NEXT_CTA_CLICK = 'kyc2_email_verify_next_clicked'

export const KYC_SELFIE_PAGEVIEW = 'kyc2_selfie_viewed'
export const KYC_SELFIE_NEXT_CTA_CLICKED = 'kyc2_selfie_next_clicked'

export const KYC_RISK_PROFILE_PAGEVIEW = 'kyc2_risk_profile_viewed'
export const KYC_RISK_PROFILE_NEXT_CTA_CLICK = 'kyc2_risk_profile_next_clicked'

export const KYC_ADDRESS_CONSENT_PAGEVIEW = 'kyc2_address_consent_viewed'
export const KYC_ADDRESS_CONSENT_NEXT_CTA_CLICK =
  'kyc2_address_consent_next_clicked'

export const KYC_VERIFY_ADDRESS_PAGEVIEW = 'kyc2_address_verification_viewed'
export const KYC_VERIFY_ADDRESS_NEXT_CLICK_CTA =
  'kyc2_address_verification_next_clicked'

export const KYC_USER_AGREEMENT_PAGEVIEW = 'kyc2_user_agreement_viewed'
export const KYC_USER_AGREEMENT_NEXT_CTA_CLICK =
  'kyc2_user_agreement_next_clicked'

export const KYC_PERMANENT_ADDRESS_PAGEVIEW = 'kyc2_address_permanent_viewed'
export const KYC_PERMANENT_ADDRESS_NEXT_CTA_CLICK =
  'kyc2_address_permanent_next_clicked'

export const KYC_ACCOUNTS_CONSENT_PAGEVIEW =
  'kyc2_stocks_account_consent_sbm_viewed'
export const KYC_ACCOUNTS_CONSENT_NEXT_CTA_CLICK =
  'kyc2_stocks_account_consent_sbm_next_clicked'

export const KYC_RESEND_EMAIL_OTP = 'kyc2_email_otp_resend_clicked'
export const KYC_EMAIL_OTP_PROCEED_CTA_CLICKED =
  'kyc2_email_otp_proceed_clicked'

export const KYC_IP_VERIFICATION_PAGEVIEW = 'kyc2_ip_verification_viewed'
export const KYC_IP_VERIFICATION_NEXT_CLICK_CTA =
  'kyc2_ip_verification_next_clicked'

// ------------ KYC events end ----------------

// ---------LOGIN WIDGET events----------

export const LOGIN_WIDGET_VIEW = 'login_widget_view'
export const LOGIN_GET_OTP_CTA_CLICK = 'login_get_otp_cta_click'
export const LOGIN_VERIFY_OTP_CTA_CLICK = 'login_verify_otp_cta_click'
export const LOGIN_CONTINUE_JOURNEY_CTA_CLICK =
  'login_continue_journey_cta_click'
export const LOGIN_NEW_REGISTRATION = 'login_new_registration'
export const LOGIN_CLOSE_CTA_CLICK = 'login_close_cta_click'

export const WEB_BOTTOMSHEET_VIEW = 'web_bottomsheet_view'
export const WEB_BOTTOMSHEET_CLOSE_CTA_CLICK = 'web_bottomsheet_close_cta_click'
export const WEB_BOTTOMSHEET_DOWNLOAD_APP_CTA_CLICK =
  'web_bottomsheet_download_app_cta_click'

// ---------LOGIN WIDGET events end----------

// SIP CALCULATOR
export const SIP_CALCULATOR_FREQUENCY = 'sip_calculator_frequency'
export const SIP_CALCULATOR_SLIDER_CLICKED = 'sip_calculator_slider_clicked'
export const SIP_CALCULATOR_MAIN_SIP_CTA_CLICKED =
  'sip_calculator_main_sip_cta_clicked'
export const SIP_CALCULATOR_SECONDARY_SIP_CTA_CLICKED =
  'sip_calculator_secondary_sip_cta_clicked'
export const SIP_CALCULATOR_RELATED = 'sip_calculator_related'
export const SIP_CALCULATOR_OTHERS = 'sip_calculator_others'

// Credit score
export const EN_CS_LOGGED_OUT_DETAILS_PAGE_VIEW =
  'creditscore_loggedout_details_page_view'
export const EN_CS_LOGGED_OUT_OTP_CTA_CLICK =
  'creditscore_loggedout_otp_cta_click'
export const EN_CS_LOGGED_OUT_DETAILS_CTA_CLICK =
  'creditscore_loggedout_details_cta_click'
export const EN_CS_LOGGED_OUT_OTP_PAGE_VIEW =
  'creditscore_loggedout_otp_page_view'

// ---- LOGIN V2 Popup events -----
export const LOGINV2_EVENT_CATEGORY = 'loginV2_popup'

// ------ Dashboard Events --------
export const DASHBOARD_VIEWED_EVENT = 'indmoney_web_dashboard_page_viewed'
export const DASHBOARD_HEADER_NAV_CLICK = 'indmoney_web_top_nav_clicked'
export const DASHBOARD_RIGHT_SIDE_WIDGETS_CLICK =
  'indmoney_web_right_widget_clicked'
